import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import url from 'libraries/front-end-core/core/url'
import { DOCUMENTS_MENU } from 'constants/controllers'
import { setDocumentShowAutomatedOnly, setDocumentShowFavouritesOnly } from 'redux/actions'
import { DOCUMENTS_FAVOURITING } from 'constants/feature-flags'
import Breadcrumbs from 'components/Breadcrumbs'
import CompactSwitch from 'components/CompactSwitch'

export default function DocumentsAllHeader () {
  const dispatch = useDispatch()
  const showFavouritesOnly = useSelector(state => state.documents.showFavouritesOnly)
  const showAutomatedOnly = useSelector(state => state.documents.showAutomatedOnly)

  return (
    <div>
      <div className='layout-width-constraint mv6'>
        <Breadcrumbs
          crumbs={[
            {
              label: 'Documents',
              href: url(DOCUMENTS_MENU),
              analytics: {
                category: 'Documents',
                action: 'Back to menu'
              }
            }
          ]}
          current='All Documents'
          icon='documents'
        >
          <div className='flex items-center mlauto gap3'>
            <CompactSwitch
              label={
                <span className='dib w11-half'>
                  Automated only
                </span>
              }
              labelPlacement='end'
              checked={showAutomatedOnly}
              onChange={() => {
                dispatch(setDocumentShowAutomatedOnly(!showAutomatedOnly))
              }}
              data-event-category='Automated Documents'
              data-event-action={showAutomatedOnly ? 'Untoggle' : 'Toggle'}
            />
            {DOCUMENTS_FAVOURITING && (
              <CompactSwitch
                label={
                  <span className='dib w11-half'>
                    Favourites only
                  </span>
                }
                labelPlacement='end'
                checked={showFavouritesOnly}
                onChange={() => {
                  dispatch(setDocumentShowFavouritesOnly(!showFavouritesOnly))
                }}
                data-event-category='Favourites'
                data-event-action={showFavouritesOnly ? 'Toggle-Off' : 'Toggle-On'}
                data-event-label='All Documents'
              />
            )}
          </div>
        </Breadcrumbs>
      </div>
    </div>
  )
}
